import AxiosConfig from '@/config/axios-config'

export const CasosAPI = {

  obterCasos (params) {
    return AxiosConfig.jaleklinicoAPI().post('/jaleklinico/casos', params)
      .then(response => response.data)
  },

  async obterUmCaso (idJaleklinico) {
    return AxiosConfig.jaleklinicoAPI().get(`/jaleklinico/casos/${idJaleklinico}`)
      .then(response => response.data)
  },

  salvarExecucaoUsuario (params) {
    return AxiosConfig.jaleklinicoAPI().post(`/jaleklinico/casos/${params.jaleklinico_id}`, params)
      .then(response => response.data)
  },

  salvarAvaliacaoUsuario (params) {
    return AxiosConfig.jaleklinicoAPI().post(`/jaleklinico/avaliacao/${params.jaleklinico_id}`, params)
      .then(response => response.data)
  }

}

export default CasosAPI
